"use client";

import { Analytics } from "@vercel/analytics/react";

export function AnalyticsWrapper() {
  return <Analytics />;
}
